import classNames from "classnames"
import React from "react"

import { Color } from "../../../constants/V2/color"

import { getBackgroundColorClass } from "@utils/V2/color"

type Props = {
  className?: string
  backgroundColor: Color
  height: number
  enableNegativeMargin?: boolean
}

const SpacerSection = ({
  className,
  backgroundColor,
  height,
  enableNegativeMargin = false,
  ...props
}: Props) => {
  return (
    <div
      style={{ height: `${height}px` }}
      className={classNames(
        "w-full",
        getBackgroundColorClass(backgroundColor),
        { "-mb-lg": enableNegativeMargin },
        className
      )}
      {...props}
    />
  )
}

export default SpacerSection
